module.exports = __webpack_public_path__ + "img/paris.54411325.jpg";